import Swiper, {Pagination} from "swiper";


const inspirationBlock = document.querySelectorAll('.layout-inspiration-block');

if (!_.isEmpty(inspirationBlock)) {
    Array.from(inspirationBlock).forEach(item => {
        if (_.isNil(item.querySelector('.field--name-field-teasers'))) {
            return;
        }
        if(!_.isNil(item.querySelector('.show-in-rows'))){
            return;
        }

        item.querySelector('.field--name-field-teasers').classList.add('swiper-container');

        const swiper = new Swiper(item.querySelector('.swiper-container'), {
            createElements: true,
            slidesPerView: 1.25,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                991: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            }
        })
    })
}

const inspirationEventBlock = document.querySelectorAll('.layout-inspiration-block-events, .view-events.view-display-id-block_4');

if (!_.isEmpty(inspirationEventBlock)) {
    Array.from(inspirationEventBlock).forEach(item => {

        if (_.isNil(item.querySelector('.events-wrapper'))) {
            return;
        }

        item.querySelector('.events-wrapper').classList.add('swiper-container');

        const fieldItems = item.querySelectorAll('.events-wrapper .swiper-wrapper > .field__item, .events-wrapper .swiper-wrapper > .views-row');

        fieldItems.forEach(field => {
            field.classList.add('swiper-slide');
        });

        const swiperEvents = new Swiper(item.querySelector('.swiper-container'), {
            createElements: true,
            slidesPerView: 1.25,
            spaceBetween: 16,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5
                },
                991: {
                    slidesPerView: 3
                },
                1199: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                }
            }
        })
    })
}

// const newsItems = document.querySelectorAll('.layout-news-items');
//
// if (!_.isEmpty(newsItems)) {
//     Array.from(newsItems).forEach(item => {
//
//         if (_.isNil(item.querySelector('.view-latest-news'))) {
//             return;
//         }
//
//         item.querySelector('.view-latest-news .view-content').classList.add('swiper-container');
//
//         const fieldItems = item.querySelectorAll('.view-latest-news .view-content > .views-row');
//
//         fieldItems.forEach(field => {
//             field.classList.add('swiper-slide');
//         });
//
//         const swiperEvents = new Swiper(item.querySelector('.swiper-container'), {
//             createElements: true,
//             slidesPerView: 1.25,
//             spaceBetween: 16,
//             pagination: {
//                 el: ".swiper-pagination",
//                 clickable: true,
//             },
//             breakpoints: {
//                 768: {
//                     slidesPerView: 2.5
//                 },
//                 991: {
//                     slidesPerView: 3,
//                     spaceBetween: 30,
//                 }
//             }
//         })
//     })
// }

// const instagramFeed = document.querySelector('.instagram-feed');
//
// if (!_.isNil(instagramFeed)  && !_.isNil(instagramFeed.querySelector('.swiper-container'))) {
//     const swiper = new Swiper(instagramFeed.querySelector('.swiper-container'), {
//         slidesPerView: 1.45,
//         spaceBetween: 0,
//         modules: [Pagination],
//         pagination: {
//             el: ".swiper-pagination",
//             clickable: true,
//         },
//         breakpoints: {
//             768: {
//                 slidesPerView: 4.25
//             },
//             991: {
//                 slidesPerView: 6,
//             }
//         }
//     })
// }